import React from "react";
import MultiSelectDropdown from "../../../components/multiSelectDropdown/multiSelectDropdown";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/checkInSaga";

const CustomDateRanges = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.checkIns.rangeOptions);
  const selectedFilters = useSelector((state) => state.checkIns.selectedRangeOption);

  const handleUpdateOptions = (data) => {
    dispatch(actionCreators.updateCustomRange(data));
  };

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedFilters}
      includeFilter={false}
      onSelectChange={handleUpdateOptions}
    />
  );
};

export default CustomDateRanges;
